angular.module("digitalLeasing.module").component("additionalBoatInfo", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/additionalBoatInfo/additionalBoatInfo.view.html",
    bindings: {
        model: "=",
        boatIsOk: "&",
        boatIsNotOk: "&",
        initialTabIndex: "="
    },
    controllerAs: "additionalBoatInfoCtrl",
    controller: AdditionalBoatInfoController
});

function AdditionalBoatInfoController($typeDomainService) {
    var self = this;

    self.supportModel = {
        dropdown: {
            boatType: []
        },
        initialIndex: 0,
        isM12: false
    }

    self.$onInit = function () {
        
        self.supportModel.initialIndex = self.initialTabIndex || 0;
        getBoatType();
        validateBoatManagement();
    };

    var getBoatType = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_BOAT_INFO", "BOAT_TYPE").then(function (response) {
            self.supportModel.dropdown.boatType = response.domainList;
        });
    };

    self.handleChange = function (property, value) {

        switch (property) {
            case "tipo":
                self.model.tipo = value.name;
                break;
            case "capitaneriaPorto":
                self.model[property] = value;
                if (!self.model.capitaneriaPorto) {
                    self.model.portoIscrizione = "";
                }
                break;
            default:
                self.model[property] = value;
                break;
        }

        validateBoatManagement();
    }

    var validateBoatManagement = function () {
        var testPortoIscrizione = false;
        var test = self.model.tipo && self.model.matricola && self.model.cantiere &&
            self.model.modello && self.model.description && self.model.lunghezza &&
            self.model.larghezza;

        if (!self.model.capitaneriaPorto) {
            testPortoIscrizione = true;
        } else {
            testPortoIscrizione = self.model.portoIscrizione &&
                self.model.notaio && self.model.telNotaio
        }

        if (test && testPortoIscrizione) {
            self.boatIsOk();
        } else {
            self.boatIsNotOk();
        }
    }

}